module.exports = __webpack_public_path__ + "static/media/how_we_work1.008e7a0c.svg";